const React = require('react')
const PropTypes = require('prop-types')
const { Row, Media } = require('reactstrap')
require('@styles/pages/home/generalInfo.home/statistics.general.home.css')

const GeneralStatistics = props => {
    return (
        <Row>
            <Media className='general-statistics'>
                <Media left={true} className='general-statistics-icon-wrapper'>
                    <Media
                        object={true}
                        src={props.iconUrl}
                        className='general-statistics-icon'
                    />
                </Media>
                <Media body={true} className='general-statistics-text-wrapper'>
                    <Media body={true} className='general-statistics-title'>
                        {props.title}
                    </Media>
                    <Media body={true} className='general-statistics-value'>
                        {props.value}
                    </Media>
                </Media>
            </Media>
        </Row>
    )
}

GeneralStatistics.propTypes = {
    iconUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

module.exports = { GeneralStatistics }
